export const DEBOUNCE_TIME = 300
